import React, { Component } from 'react';
import imageButtonYes from './img/btn11.png';
import imageButtonNo from './img/btn12.png';
import imagePromptToFinish from './img/text04.png';
import './view.css';

class ViewResult extends Component {
    render() {
        return (
            <div>
                <div id="overlay">
                    <div onClick={this.props.onClickModal} id="overlay"></div>
                </div>
                <div className="alertimage" id="alert">
                    <div className="window">
                        <img src={imagePromptToFinish}></img>
                        <div className="buttons">
                            <div onClick={this.props.onClickYes}>
                                <img src={imageButtonYes} id="yes"></img>
                            </div>
                            <div onClick={this.props.onClickNo}>
                                <img src={imageButtonNo} id="no"></img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ViewResult;
